<template>
  <div class="table-list page-box">
    <div class="page-content">
      <div class="content-header">
        <vs-button
          type="info"
          class="search-btn btn box-item"
          @click="searchHandle"
        >刷新</vs-button>
        <vs-button
          v-if="isAuth('sys:data:permission:table:update')"
          class="add-btn btn box-item"
          @click="addHandle"
        >新增</vs-button>
        <vs-button
          v-if="isAuth('sys:data:permission:table:delete')"
          :disabled="selected.length < 1"
          class="mutil-btn"
          @click="deleteHandle()"
        >批量删除</vs-button>
      </div>
      <div class="vs-table-outer">
        <vs-table
          multiple
          v-model="selected"
          :data="listData"
        >
          <template
            slot="thead">
            <vs-th>
              ID
            </vs-th>
            <vs-th>
              所属维度
            </vs-th>
            <vs-th>
              表名
            </vs-th>
            <vs-th>
              字段名
            </vs-th>
            <vs-th>
              备注
            </vs-th>
            <vs-th>
              操作
            </vs-th>
          </template>
          <template slot-scope="{data}">
            <vs-tr
              v-for="(tr, index) in data"
              :key="index"
              :data="tr"
            >
              <vs-td>
                {{tr.id}}
              </vs-td>
              <vs-td>
                {{tr.dimensionName}}
              </vs-td>
              <vs-td>
                {{tr.tableName}}
              </vs-td>
              <vs-td>
                {{tr.columnName}}
              </vs-td>
              <vs-td>
                {{tr.remark}}
              </vs-td>
              <vs-td>
                <el-button
                  type="text"
                  v-if="isAuth('sys:data:permission:table:update')"
                  class=""
                  @click.native="editHandle(tr)"
                >修改</el-button>
                <el-button
                  type="text"
                  v-if="isAuth('sys:data:permission:table:delete')"
                  class="delete-btn"
                  @click.native="deleteHandle(tr)"
                >删除</el-button>
              </vs-td>
            </vs-tr>
          </template>
        </vs-table>
      </div>
      <div class="pagination-outer" v-if="total">
        <div class="paginnation-left">
          <size-change @sizeChange="sizeChange"></size-change>
          <span class="tatol-count">合计 {{total}} 条</span>
        </div>
        <vs-pagination
          class="pagination-box"
          :max="max"
          :total="pageSize"
          v-model="page"
        ></vs-pagination>
      </div>
    </div>
    <add-table-dialog
      :dialog-show="addDialogShow"
      @close="closeAddDialog"
      @add-success="addSuccess"
    ></add-table-dialog>
    <edit-table-dialog
      :form-data="currentRow"
      :dialog-show="editDialogShow"
      @close="closeEditDialog"
      @add-success="editUserSuccess"
    ></edit-table-dialog>
    <multiple-delete-dialog
      ref="muldelete"
      :ids="ids"
      @sure-delete="confirmDelete"
    ></multiple-delete-dialog>
  </div>
</template>

<script>
import multipleDeleteDialog from "@/components/public/multipleDeleteDialog";
import editTableDialog from '@/components/sys/dataPermission/table-list/editTableDialog'
import addTableDialog from "@/components/sys/dataPermission/table-list/addTableDialog";
import { mapGetters } from 'vuex'
import { colorRgba,parseTime } from '@/utils/index'
import initData from "@/mixins/initData";
import {deteleTable} from "@/api/sys/dataPermission/tableList";
export default {
  name: "index",
  components: {
    addTableDialog,
    editTableDialog,
    multipleDeleteDialog,
  },
  data() {
    return {
      name: '',
      selected: [],
      red: '#D85E5F',
      green: '#41B883',
      addDialogShow: false,
      editDialogShow: false,
      currentRow: {
        id: '',
      },
      ids: [],
    }
  },
  mixins: [initData],
  computed: {
    ...mapGetters(['themeColor','userInfo']),
  },
  mounted(){
    this.init();
  },
  methods: {
    parseTime,
    beforeInit(){
      this.url = '/wx/sys/dataPermissionTable/list';
      this.params = {
        page: this.page,
        limit: this.size,
        'sidx': 'id',
        'order':'desc'
      }
      return true;
    },
    addHandle(){
      setTimeout(() => {
        this.addDialogShow = true;
      },200);
    },
    addSuccess(){
      this.addDialogShow = false;
      this.searchHandle();
    },
    editHandle(row){
      setTimeout(() => {
        this.editDialogShow = true;
        this.currentRow = row;
      },200);
    },
    editUserSuccess(){
      this.editDialogShow = false;
      this.searchHandle();
    },
    closeEditDialog(){
      this.editDialogShow = false;
    },
    deleteHandle(row){
      this.ids = row ? [row.id] : this.selected.map(item => item.id);
      this.$refs.muldelete.dialogShow = true;
    },
    confirmDelete(ids){
      deteleTable(ids).then((res) => {
        this.$message({
          type: 'success',
          message: '已删除'
        });
        this.$refs.muldelete.dialogShow = false;
        this.searchHandle();
      })
    },
    closeAddDialog(){
      this.addDialogShow = false;
    },
    searchHandle(){
      this.page = 1;
      this.init();
    },
  },
}
</script>

<style lang="scss" scoped>
.table-list {
  .box-item {
    margin-bottom: 10px;
  }
  .btn {
    margin-right: 10px;
  }
  .vs-table-outer {
    .vs-con-table {
      min-width: 1200px;
    }
  }
  .tag-box {
    padding: 5px 10px;
    border-radius: 15px;
  }
  .reject-reason {
    max-width: 120px;
  }
}
</style>
